import { useState } from "react";

/**
 * Image de hero avec fallback dégradé (bleu institutionnel → or) si la source
 * est vide, invalide, ou renvoie une 404. Utilisée pour toutes les bannières
 * de page : plus aucun placeholder Unsplash ou image de démonstration —
 * seulement les images ajoutées via le tableau de bord.
 */
export default function HeroImage({ src, alt = "", className = "" }) {
  const [errored, setErrored] = useState(false);
  const showImage = src && !errored;

  return (
    <>
      {showImage ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover ${className}`}
          onError={() => setErrored(true)}
        />
      ) : (
        <div
          className={`absolute inset-0 w-full h-full ${className}`}
          data-testid="hero-fallback"
          style={{
            background:
              "linear-gradient(135deg, #0A2E52 0%, #144C86 45%, #0A2E52 65%, #7c5d18 100%)",
          }}
        >
          <div
            className="absolute inset-0 opacity-25"
            style={{
              backgroundImage:
                "radial-gradient(circle at 20% 30%, rgba(212,175,55,0.4) 0%, transparent 60%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.15) 0%, transparent 55%)",
            }}
          />
        </div>
      )}
    </>
  );
}
